import colors from "../../Constants/colors";

export const drawerContainer = {
  display: "flex",
  overflowY: "hidden", // Disable vertical scrolling
  scrollbarWidth: "none", // Firefox: Hide scrollbar
  "&::WebkitScrollbar": {
    display: "none", // Chrome, Safari: Hide scrollbar
  },
};

export const drawerSubContainer = {
  display: "flex",
  overflowY: "hidden", // Disable vertical scrolling
  scrollbarWidth: "none", // Firefox: Hide scrollbar
  "&::WebkitScrollbar": {
    display: "none", // Chrome, Safari: Hide scrollbar
  },
  marginLeft: "60px",
  bgcolor: "white",
  padding: "0px",
  width: { xs: "90%", md: "96.1%" },
  minWidth: { xs: "90%", md: "96.1%" },
};

export const drawerMain = {
  flexGrow: 1,
  bgcolor: colors.extremeBlue,
  p: 0,
  width: "90%",
  overflowY: "hidden", // Disable vertical scrolling
  scrollbarWidth: "none", // Firefox: Hide scrollbar
  "&::WebkitScrollbar": {
    display: "none", // Chrome, Safari: Hide scrollbar
  },
};

export const motionDivContainer = {
  position: "fixed",
  height: "100vh",
  backgroundColor: "var(--colorPrimary)",
  borderRight: "1px solid #333",
  zIndex: 10, // Ensures it overlays content
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  width: "60px",
};

export const logoSection = {
  display: "flex",
  alignItems: "center",
  padding: "12px",
  backgroundColor: "var(--colorPrimary)",
};

export const ql_text = {
  color: "#fff",
  fontSize: "14px",
  marginLeft: "10px",
  padding: 0,
};

export const listItemButtonStyles = {
  display: "flex",
  alignItems: "center",
  borderRadius: "6px",
  margin: "4px",
};

export const listItemIconStyles = {
  color: "inherit",
  minWidth: "40px", // Matches collapsed sidebar width
  display: "flex",
  justifyContent: "center", // Centers the icon
};

export const profileLogoutContainer = {
  padding: "8px",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
};

export const menuWhenClickedStyles = {
  "& .MuiPaper-root": {
    backgroundColor: "#1E1F28",
    color: "#fff",
  },
  "& .MuiMenuItem-root": {
    "&:hover": { backgroundColor: "var(--bgBlue)" },
  },
};
